import { useParams } from 'react-router-dom';

import { FetchImage } from 'components';

import { getIsNew } from 'utils';

import { productStore } from '../../store';

export const ProductImage = () => {
  const imgId = productStore((state) => state.imgId);

  const { productId } = useParams();

  const isNew = getIsNew(productId);

  return (
    <FetchImage
      alt='Product'
      isNew={isNew}
      imgId={imgId}
      preview={false}
    />
  );
};
